import { render, staticRenderFns } from "./adjustable_tree.vue?vue&type=template&id=0c5054a4&scoped=true"
import script from "./adjustable_tree.vue?vue&type=script&lang=js"
export * from "./adjustable_tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5054a4",
  null
  
)

export default component.exports